import AuthLayout from "../Layout";
import LoginClient from "./client";



export default function Login(){
    return (
        <AuthLayout>
            <LoginClient/>
        </AuthLayout>
    )
}